import { Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AuthorizedResourcesService } from '../../../../auth/services/authorized-resources.service';
import { constants } from '../../../../../constants';

@Component({
  selector: 'mpro-region-comparison-projections',
  templateUrl: './region-comparison-projections.component.html',
  styleUrls: ['./region-comparison-projections.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RegionComparisonProjectionComponent),
      multi: true,
    },
  ],
})
export class RegionComparisonProjectionComponent
  implements OnInit, ControlValueAccessor
{
  public projections: number[] = [];
  public currentlySelectedProjections: number[] = [];
  public isDisabledValue: boolean = false;
  private onChange: any = () => {};
  private onTouch: any = () => {};

  constructor(private authResourcesService: AuthorizedResourcesService) {}

  public ngOnInit() {
    this.projections = this.generateProjections(
      this.authResourcesService.startYear,
      this.authResourcesService.endYear
    );
  }

  public writeValue(value: number[]): void {
    if (value) {
      this.currentlySelectedProjections = value;
    }
  }

  public registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean) {
    this.isDisabledValue = isDisabled;
  }

  public onProjectionSelected(checked: boolean, projection: number) {
    if (checked) {
      this.currentlySelectedProjections.push(projection);
    } else {
      const indexToUncheck = this.currentlySelectedProjections.findIndex(
        (pr) => pr === projection
      );
      if (indexToUncheck !== -1) {
        this.currentlySelectedProjections.splice(indexToUncheck, 1);
      }
    }

    this.onChange(this.currentlySelectedProjections.sort((a, b) => a - b));
  }

  public getCurrentProjectionsList(): string {
    return this.currentlySelectedProjections.join('; ');
  }

  public isChecked(projection: number): boolean {
    return !!this.currentlySelectedProjections.find((pr) => pr === projection);
  }

  public isDisabled(projection: number): boolean {
    return (
      this.currentlySelectedProjections.length === 3 &&
      !this.isChecked(projection)
    );
  }

  private generateProjections(startYear: number, endYear: number): number[] {
    return Array.from(Array(endYear - startYear + 1), (_, i) => startYear + i);
  }
}
